import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SortidaPartidaDetailComponent } from './components/sortida-partida-detail/sortida-partida-detail.component';
import { IdentityGuard } from '../services/identity.guard';
import { MainComponent } from './components/main/main.component';
import { EntradaDetailComponent } from '../components/mercaderies/entrada-detail/entrada-detail.component';
import { FotosComponent } from './components/fotos/fotos.component';
import { MesuraComponent } from './components/mesura/mesura.component';

const partidaRoutes: Routes = [
    {
        path: 'sortida-partida',
        component: MainComponent,
        children: [
            {
                path: '',
                component: EntradaDetailComponent
            },
            {path: ':sortida/:id', component: SortidaPartidaDetailComponent, canActivate: [IdentityGuard]},
            {path: ':sortida/:id/fotos', component: FotosComponent, canActivate: [IdentityGuard]},
            {path: ':sortida/:id/mesura', component: MesuraComponent, canActivate: [IdentityGuard]},
        ],
    }
];

@NgModule({
    imports: [RouterModule.forChild(partidaRoutes)],
    exports: [RouterModule]
})
export class SortidaPartidaRoutingModule {
}
